import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import React, { ChangeEvent, FC, useState } from "react";
import { Auth } from "aws-amplify";
import { useHistory } from "react-router-dom";

import { CognitoAuthChallenge, resolveAuthChallenge } from "../../../../utils/cognitoAuthChallenge";
import { getAppHomePath } from "../../../../utils/getAppHomePath";

type NewPasswordRequiredFormProps = {
  authUser: any;
  onChallenge: (user: any, challenge: CognitoAuthChallenge) => void;
  dispatchSetSession?: (session: any) => void;
};

const NewPasswordRequiredForm: FC<NewPasswordRequiredFormProps> = ({ authUser, onChallenge, dispatchSetSession }) => {
  const [confirmErrorMsg, setConfirmErrorMsg] = useState("");
  const [newPassword, setNewPassword] = useState<string>("");
  const [newConfirmPassword, setNewConfirmPassword] = useState<string>("");
  const [didErrorOccured, setDidErrorOccured] = useState(false);

  const history = useHistory();

  const handleNewPasswordChange = (e: ChangeEvent<HTMLInputElement>) => {
    setNewPassword(e.target.value);
  };

  const handleNewPasswordConfirmChange = (e: ChangeEvent<HTMLInputElement>) => {
    setNewConfirmPassword(e.target.value);
  };

  const handleSubmit = async (e: React.SyntheticEvent) => {
    e.preventDefault();
    if (newConfirmPassword !== newPassword) {
      setConfirmErrorMsg("Passwords Must Match");
      return;
    }

    try {
      const confirmedUser = await Auth.completeNewPassword(authUser, newPassword, {});
      const challenge = await resolveAuthChallenge(confirmedUser);

      if (challenge.type !== "SUCCESS") {
        onChallenge(confirmedUser, challenge.type);
        return;
      }

      const session = {
        credentials: {
          accessToken: confirmedUser.signInUserSession.accessToken.jwtToken,
          idToken: confirmedUser.signInUserSession.idToken.jwtToken,
          refreshToken: confirmedUser.signInUserSession.refreshToken.token,
        },
        user: {
          userName: confirmedUser.username,
        },
      };
      if (dispatchSetSession) {
        await dispatchSetSession(session);
      }
      history.push(getAppHomePath(), { fromLogin: true });
    } catch (error) {
      setDidErrorOccured(true);
      setConfirmErrorMsg(`There was an error updating your password: ${error}`);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <TextField
        error={didErrorOccured}
        className="w-100"
        id="newPassword"
        label="New Password"
        value={newPassword}
        onChange={handleNewPasswordChange}
        name="newPassword"
        margin="normal"
        variant="outlined"
        type="password"
        required
      />
      <TextField
        error={didErrorOccured}
        className="w-100 mt-1"
        id="confirmNewPassword"
        label="Confirm New Password"
        value={newConfirmPassword}
        onChange={handleNewPasswordConfirmChange}
        name="password"
        margin="normal"
        variant="outlined"
        type="password"
        required
      />
      <Typography variant="subtitle2" className="font-weight-bold text-danger mb-2" align="center">
        {confirmErrorMsg}
      </Typography>
      <Button variant="outlined" size="large" className="text-primary" type="submit">
        Confirm and Log In
      </Button>
    </form>
  );
};

export default NewPasswordRequiredForm;
